/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DelegateProfilePage_manager = {
    readonly " $fragmentRefs": FragmentRefs<"ProfileCard_manager">;
    readonly " $refType": "DelegateProfilePage_manager";
};
export type DelegateProfilePage_manager$data = DelegateProfilePage_manager;
export type DelegateProfilePage_manager$key = {
    readonly " $data"?: DelegateProfilePage_manager$data;
    readonly " $fragmentRefs": FragmentRefs<"DelegateProfilePage_manager">;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "DelegateProfilePage_manager",
    "type": "Manager",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ProfileCard_manager",
            "args": null
        }
    ]
} as any);
(node as any).hash = '665cb26f1e5f1502f7ec77ac0ae54cd9';
export default node;
